import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, Typography } from '@emburse/embark-core';
import { useContext } from 'react';
import AlertsDataGrid from './AlertsDataGrid';
import AlertsDrawer from './Drawer';
import { AuditAlertsContext } from '../../views/AuditAlerts/AuditAlertsProvider';
import AlertsLoading from '../../views/AuditAlerts/AlertsLoading';
import SingleColumnLayout from '../../components/Layouts/SingleColumnLayout';
function AuditAlerts() {
    const { loading, error } = useContext(AuditAlertsContext);
    return (_jsx(SingleColumnLayout, { children: _jsxs(Stack, { alignItems: "flex-start", spacing: 6, children: [_jsx(Typography, { variant: "h4", children: "InstantAudit Alerts" }), loading && _jsx(AlertsLoading, {}), !loading && !error && _jsx(AlertsDataGrid, {}), !loading && !error && _jsx(AlertsDrawer, {})] }) }));
}
export default AuditAlerts;
